import Banner from "./Banner/Banner";
import HomeBanner from "./HomeBanner/HomeBanner";
import Navbar from "./Navbar/Navbar";
import { useLocation } from "react-router-dom";

export default function Header({ currentLanguage, onLanguageChange }) {
  const location = useLocation();

  const hideBannerOn = ["/blog-detail"];

  const shouldHideBanner =
    hideBannerOn.includes(location.pathname) ||
    location.pathname.startsWith("/blog-detail/");

  const isHomePage = location.pathname === "/";

  return (
    <>
      {/* Show Navbar only when NOT homepage */}
      {!isHomePage && (
        <Navbar 
          onLanguageChange={onLanguageChange}
          currentLanguage={currentLanguage}
        />
      )}

      {/* Banners */}
      {!shouldHideBanner && (
        isHomePage ? (
          <HomeBanner 
            currentLanguage={currentLanguage}
            onLanguageChange={onLanguageChange}
          />
        ) : (
          <Banner currentLanguage={currentLanguage} />
        )
      )}
    </>
  );
}